import { BsdsCard } from '@bsds-lib-component/react';
import React from 'react';

type HomeApoliceDataCardProps = {
    numeroApolice: string;
    empresa: string;
    estipulante: string;
    sucursal: string;
    produto: string;
    ramo: string;
    contrato: string;
    identEstipulante: string;
    codEmpresa: string;
    codSucursal: string;
    codProduto: string;
    codRamo: string;
    documento: string;
    vigenciaInicio: string;
    vigenciaFim: string;
};

const CARD_BASE_CLASS =
    'w-full p-6 border border-gray-100 shadow-sm transition-all duration-200 hover:shadow-md hover:shadow-lg sm:col-span-2 lg:col-span-3';

type LabeledValueProps = {
    label: string;
    value: string;
};

const LabeledValue: React.FC<LabeledValueProps> = ({ label, value }) => (
    <div className="flex flex-1 min-w-0 flex-col">
        <div className="bsds-mt-4 bsds-p-4 bg-gray-50/30 rounded-md border border-gray-100 flex flex-col bsds-gap-8">
            <span className="text-sm text-gray-300 font-small">{label}</span>
            <span className="text-sm font-semibold text-gray-900">{value}</span>
        </div>
    </div>
);

const HomeApoliceDataCard: React.FC<HomeApoliceDataCardProps> = ({
    numeroApolice,
    empresa,
    estipulante,
    sucursal,
    produto,
    ramo,
    contrato,
    identEstipulante,
    codEmpresa,
    codSucursal,
    codProduto,
    codRamo,
    documento,
    vigenciaInicio,
    vigenciaFim,
}) => {
    const ariaSummary = [
        `Dados da apolice ${numeroApolice}`,
        `Empresa ${empresa}`,
        `Estipulante ${estipulante}`,
        `Ramo ${ramo}`,
    ].join(', ');

    return (
        <BsdsCard className={CARD_BASE_CLASS} platform="web" role="listitem" aria-label={ariaSummary}>
            <div className="grid grid-cols-1 lg:grid-cols-[320px,1fr] bsds-gap-12 bsds-width-100">
                <div className="bsds-flex-direction-column bsds-align-items-start bsds-width-100">
                    <div className="bsds-display-flex bsds-justify-content-between bsds-align-items-start bsds-width-100 bsds-gap-4">
                        <span className="text-lg font-semibold text-gray-900 text-start">Dados da Apólice</span>
                        <BsdsCard
                            platform="web"
                            className="px-3 py-1 rounded-md border-0 shadow-none shrink-0 bg-gray-100 text-gray-800"
                        >
                            <span className="text-sm font-semibold text-right">{numeroApolice}</span>
                        </BsdsCard>
                    </div>

                    <div className="bsds-display-flex bsds-flex-direction-row bsds-justify-content-between bsds-align-items-center bsds-width-100 bsds-gap-8 bsds-mt-12">
                        <span className="text-sm text-gray-300 text-start shrink-0">Vigência</span>
                        <div className="bsds-display-flex bsds-flex-direction-row bsds-align-items-center bsds-gap-8">
                            <span className="text-sm text-gray-500 text-start">{vigenciaInicio}</span>
                            <span className="text-sm text-gray-500 text-start bsds-ml-4 bsds-mr-4">a</span>
                            <span className="text-sm text-gray-500 text-start">{vigenciaFim}</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 gap-2 bsds-width-100 bsds-mt-8">
                        <LabeledValue label="Empresa" value={empresa} />
                        <LabeledValue label="Estipulante" value={estipulante} />
                        <LabeledValue label="Sucursal" value={sucursal} />
                        <LabeledValue label="Produto" value={produto} />
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 bsds-width-100">
                    <LabeledValue label="Ramo" value={ramo} />
                    <LabeledValue label="Contrato" value={contrato} />
                    <LabeledValue label="Número do Documento" value={documento} />
                    <LabeledValue label="Ident. Estipulante" value={identEstipulante} />
                    <LabeledValue label="Cód. Empresa" value={codEmpresa} />
                    <LabeledValue label="Cód. Sucursal" value={codSucursal} />
                    <LabeledValue label="Cód. Produto" value={codProduto} />
                    <LabeledValue label="Cód. Ramo" value={codRamo} />
                </div>
            </div>
        </BsdsCard>
    );
};

export default HomeApoliceDataCard;